import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingBasket } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { getImageUrl } from '../config';
import { toast } from 'react-toastify';
import '../styles/ProductCard.css';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const name = product.nameAr || product.name || '';
  const image = getImageUrl(product.image);
  const soldOut = product.stock === 0;

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
    toast.success('تمت إضافة المنتج إلى السلة');
  };

  return (
    <article className="product-card">
      <Link to={'/products/' + product._id} className="product-card-link" aria-label={name}>
        <div className="product-image">
          {image ? (
            <img src={image} alt="" loading="lazy" />
          ) : (
            <span className="card-placeholder" aria-hidden="true">🌷</span>
          )}
          {product.featured && <span className="featured-badge">مميز</span>}
          {soldOut && <span className="soldout-badge">نفد المخزون</span>}
        </div>

        <div className="product-info">
          <h3 className="product-name">{name}</h3>
          {product.category && <p className="product-category">{product.category}</p>}

          <div className="product-footer">
            <span className="product-price">
              {product.price}
              <span className="currency"> دج</span>
            </span>
          </div>
        </div>
      </Link>

      <button
        type="button"
        className="add-to-cart-btn"
        onClick={handleAdd}
        disabled={soldOut}
        aria-label={'أضيفي ' + name + ' إلى السلة'}
      >
        <FaShoppingBasket aria-hidden="true" />
        <span>{soldOut ? 'غير متوفر' : 'أضيفي للسلة'}</span>
      </button>
    </article>
  );
};

export default ProductCard;
